import { useState } from "react";
import "./style.scss";
import { BallsLoader, ErroAnim } from "src/Components";

import { ReactComponent as EyeOn } from "src/Assets/Icons/eyeOn.svg";
import { ReactComponent as EyeOff } from "src/Assets/Icons/eyeOff.svg";
import { isValid } from "src/pages/services/utils";

export function SubmitButton({
  Type,
  Placeholder,
  Style,
  Class,
  Status,
  SetStatus,
  OnClick,
  Icon,
  children,
}) {
  return (
    <button
      type={Type}
      placeholder={Placeholder}
      className={`SubmitButton ${Style || ""} ${Class || ""} ${Status || ""}`}
      onClick={OnClick}
      onMouseEnter={() => {
        if (Status === "error") SetStatus("");
      }}
    >
      {Status === "" && <span className="icon">{Icon && <Icon />}</span>}
      {Status === "load" && (
        <span className="load">
          <BallsLoader />
        </span>
      )}
      {Status === "error" && (
        <span className="error">
          <ErroAnim />
        </span>
      )}
      {children}
    </button>
  );
}

export function Button({ OnClick, ClassName, Title, children }) {
  return (
    <button
      className={`${ClassName} CustomButton -shadow-small`}
      onClick={OnClick}
      title={Title ? Title : null}
    >
      {(ClassName === "active" || ClassName === "notActive") && <span>X</span>}
      {children}
    </button>
  );
}

export function CustomInput({
  Type,
  Placeholder,
  Style,
  Class,
  OnChange,
  children,
  Value,
  DefaultValue,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = Type === "password";

  const [internalValue, setInternalValue] = useState(
    Value || DefaultValue || ""
  );
  const handleChange = (e) => {
    setInternalValue(e.target.value);
    OnChange && OnChange(e);
  };

  if (Type === "select")
    return (
      <div className="CustomInput">
        <label>{Placeholder}</label>
        <select
          className={`${Style || ""} ${Class || ""}`}
          onChange={handleChange}
          value={Value}
        >
          {children}
        </select>
      </div>
    );
  else
    return (
      <div className="CustomInput">
        {(Type === "date" || Type === "month" || isValid(internalValue)) && (
          <label>{Placeholder}</label>
        )}
        <input
          type={isPassword && showPassword ? "text" : Type}
          placeholder={Placeholder}
          className={`${Style || ""} ${Class || ""}`}
          onChange={handleChange}
          value={Value}
          defaultValue={DefaultValue}
        />
        {isPassword && (
          <button
            type="button"
            className="showPass"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <EyeOff /> : <EyeOn />}
          </button>
        )}
      </div>
    );
}
